export { default } from './NewPaymentMethodList';
